import axios, { AxiosError } from "axios";
import { v4 as uuid } from "uuid";
import { ScratchpadEntryApiModel } from "../../api-models";
import { DataSubjects, getTypeFromParam } from "./subject-type";

type ApiPostResponseType = {
  success: boolean;
  error: string | null;
};

export default async function saveEntry(
  model: ScratchpadEntryApiModel,
): Promise<ApiPostResponseType> {
  if (model.pageTitle === "") {
    model.pageTitle = "Untitled";
  }

  const errorMessagePrefix = "There was an error saving this chat:";

  try {
    const postResponse = await axios.post<ScratchpadEntryApiModel>("/api/scratchpadentry", model);
    return {
      success: postResponse.status === 200,
      error: null,
    };
  } catch (e) {
    const { response } = e as AxiosError;
    return {
      success: false,
      error: response?.status?.toString().startsWith("4")
        ? `${errorMessagePrefix} ${response?.data}`
        : `${errorMessagePrefix} Server error`,
    };
  }
}

export async function getAllScratchpadEntries(): Promise<ScratchpadEntryApiModel[]> {
  try {
    const response = await axios.get<ScratchpadEntryApiModel[]>(
      "/api/scratchpadentry/getallforcurrentauthor",
    );
    return response.data;
  } catch (e) {
    return [];
  }
}

export function createNewChatEntry(
  authorId: string,
  subjectQuery?: string,
  idQuery?: string,
): ScratchpadEntryApiModel {
  const subjectType = subjectQuery ? getTypeFromParam(subjectQuery as string) : undefined;

  return {
    authorId,
    pageTitle: "Untitled",
    pageId: uuid(),
    subjectUserId: subjectType === DataSubjects.USER ? (idQuery as string) : "",
    subjectTeamId: subjectType === DataSubjects.TEAM ? idQuery : undefined,
    subjectOrgId: subjectType === DataSubjects.ORG ? idQuery : undefined,
    text: "",
  };
}

export async function deleteChatEntry(
  authorId: string,
  pageId: string,
): Promise<ApiPostResponseType> {
  const errorMessagePrefix = "There was an error deleting this chat:";

  try {
    const response = await axios.delete(`/api/scratchpadentry/${authorId}/${pageId}`);
    return {
      success: response.status === 200,
      error: null,
    };
  } catch (e) {
    const { response } = e as AxiosError;
    return {
      success: false,
      error: response?.status?.toString().startsWith("4")
        ? `${errorMessagePrefix} ${response?.data}`
        : `${errorMessagePrefix} Server error`,
    };
  }
}
